import React from "react";

import Form from "antd/es/form";
import { useIntl } from "react-intl";

import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import { Alert, TextField } from "@mapmycustomers/ui";

import styles from "./Common.module.scss";

interface Props {
  field: IField;
  required?: boolean;
  showInfo?: boolean;
}

const DealLossCommentField: React.FC<Props> = ({ field, required, showInfo }) => {
  const intl = useIntl();

  return (
    <div className={styles.containerWithAlert}>
      <Form.Item label={field.displayName} name={["default", field.name]} required={required}>
        <TextField />
      </Form.Item>
      {showInfo && (
        <Alert
          message={intl.formatMessage({
            id: "settings.formLayouts.canvas.dealLossComment.alert",
            defaultMessage:
              "Loss Comment appears only in 'Closed Lost' stages. Create variants to display it in other stages or remove it from the layout entirely.",
          })}
          showIcon
          type="info"
        />
      )}
    </div>
  );
};

export default DealLossCommentField;
